import keys from './keys';
import useApiQuery from '../useApiQuery';

const useGetUpcomingInvoice = () => {
  const query = useApiQuery({
    queryKey: keys.upcomingInvoice,
    requestUrl: '/customer/upcomingInvoice',
  });

  return {
    invoice: query.data,
    invoiceError: query.error,
    isInvoiceFetchError: query.isError,
    isInvoiceFetchSuccess: query.isSuccess,
    isInvoiceFetching: query.isFetching,
    isInvoiceLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetUpcomingInvoice;
